import { onAuthStateChanged, getAuth } from 'firebase/auth'
import firebaseApp from './firebase'
import { useStore } from 'utils/store'

const auth = getAuth(firebaseApp)

export const initializeAuth = () => {
  onAuthStateChanged(
    auth,
    user => {
      useStore.setState({ user, loading: false })
    },
    error => console.log(error)
  )
}
